import axios, { AxiosResponse } from 'axios';
import { httpClient } from '@teachur/http-client';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000';
// const API_URL = 'https://api.newlaneuniversity.com';
const API_AI_URL = import.meta.env.VITE_API_AI_URL || 'https://ai-api.newlaneuniversity.com';

const getHeaders = () => {
  const token = localStorage.getItem('accessToken');
  return {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`,
  };
};

const ApiService = {
  get: async <T = any>(path: string, params?: any): Promise<AxiosResponse<T>> =>
    httpClient.get<T>(path, { params }),

  post: async <T = any>(path: string, data: any): Promise<AxiosResponse<T>> =>
    httpClient.post<T>(path, data),

  put: async <T = any>(path: string, data: any): Promise<AxiosResponse<T>> =>
    httpClient.put<T>(path, data),

  delete: async (path: string, data?: any, params?: any): Promise<any> =>
    httpClient.delete(path, { data, params }),

  postAI: async (path: string, data: any): Promise<any> =>
    axios
      .post(`${API_AI_URL}${path}`, data, {
        headers: getHeaders(),
      })
      .catch((err) => Promise.reject(err.response)),
  // path must start with /
  getUrl: (path: string) => `${API_URL}${path}`,
  getHeaders: () => getHeaders(),
  getUploadHeaders: () => ({
    Authorization: getHeaders().Authorization,
  }),
};

export default ApiService;
